import { DrawerClose, DrawerCloseButton, onCloseDrawer } from './drawer'
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  DrawerFooter,
} from './drawer'
import { Button } from '../button'

function UI_Drawer({
  children,
  items,
  title,
  description,
  cancelButtonLabel = 'cancel',
}: {
  children: React.ReactNode
  items: {
    label: string | React.ReactNode
    icon?: React.ReactNode
    onClick: React.MouseEventHandler<HTMLDivElement>
  }[]
  title?: string
  description?: string
  dir?: 'rtl' | 'ltr'
  cancelButtonLabel?: string
}) {
  return (
    <Drawer>
      <DrawerTrigger asChild>{children}</DrawerTrigger>
      <DrawerContent>
        <div className='mx-auto w-full '>
          <DrawerHeader>
            {title && <DrawerTitle>{title}</DrawerTitle>}
            {description && (
              <DrawerDescription>{description}</DrawerDescription>
            )}
          </DrawerHeader>

          <div className='p-4 pb-0 w-full'>
            <div className='grid flex-1 auto-rows-min gap-6 px-4'>
              {items.map((item, index) => (
                <div key={index} className='grid gap-3' onClick={item.onClick}>
                  {item.icon}
                  {item.label}
                </div>
              ))}
            </div>
          </div>
          <DrawerFooter>
            <DrawerClose />

            <DrawerCloseButton asChild>
              <Button variant='ghost' width='full' size='sm' color='neutral'>
                {cancelButtonLabel}
              </Button>
            </DrawerCloseButton>
          </DrawerFooter>
        </div>
      </DrawerContent>
    </Drawer>
  )
}

export { UI_Drawer, onCloseDrawer }
